const BASE = '/api/customer';
async function jsonFetch(url, opts) {
  const r = await fetch(url, opts);
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.error || 'خطای ارتباط با سرور.');
  return data;
}
export const customerApi = {
  requestOtp: (phone) => jsonFetch(`${BASE}/auth/request-otp`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ phone }) }),
  verifyOtp: (phone, otp) => jsonFetch(`${BASE}/auth/verify-otp`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ phone, otp }) }),
  signedUrl: (kind, format, phoneToken, contextToken, mimeType, sizeBytes) => jsonFetch(`${BASE}/uploads/signed-url`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      kind, format, mime_type: mimeType, size_bytes: sizeBytes,
      phone_token: phoneToken, context_token: contextToken,
    }) }),
  register: (payload) => jsonFetch(`${BASE}/register`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }),
};
export async function uploadNationalId(file, phoneToken, contextToken) {
  const fmt = file.type === 'application/pdf' ? 'pdf' : 'image';
  const { signedUrl, path } = await customerApi.signedUrl(
    'national_id', fmt, phoneToken, contextToken, file.type, file.size,
  );
  const put = await fetch(signedUrl, { method: 'PUT', headers: { 'Content-Type': file.type }, body: file });
  if (!put.ok) throw new Error('آپلود فایل ناموفق بود.');
  return path;
}
